export default __webpack_public_path__ + "static/media/zodiacToto-Dog.94590436.png";